import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";

export default function NavigationHeader({ onRequestInvite }) {
  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#E2D9CD]/70 bg-[#FAF6F0]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 sm:px-12 lg:px-20">
        <a href="#top" data-testid="brand-logo" className="font-serif text-xl tracking-tight text-[#1C1815]">
          Olden<span className="italic text-[#6B1D2F]">Goods</span>
          <span className="ml-2 hidden align-middle font-mono text-[10px] uppercase tracking-[0.25em] text-[#8A8075] sm:inline">
            Est. 2026
          </span>
        </a>

        <div className="flex items-center gap-5">
          <div
            data-testid="under-construction-status-badge"
            className="hidden items-center gap-2 border border-[#C59B27]/50 bg-[#C59B27]/10 px-3 py-1.5 sm:flex"
          >
            <span className="animate-status h-1.5 w-1.5 rounded-full bg-[#C59B27]" />
            <span className="font-mono text-[10px] font-medium uppercase tracking-[0.25em] text-[#6B1D2F]">
              Under Construction
            </span>
          </div>
          <button
            data-testid="collector-invite-nav-btn"
            onClick={onRequestInvite}
            className="group flex items-center gap-2 border border-[#1C1815] bg-[#1C1815] px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#FAF6F0] transition-colors duration-300 hover:bg-[#6B1D2F] hover:border-[#6B1D2F]"
          >
            <KeyRound className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-rotate-12" />
            Request Invite
          </button>
        </div>
      </div>
    </motion.header>
  );
}
